import Axios from '@/services/Axios';
import { TokenUtils } from '@/utils/TokenUtils';
import { ListItem } from '@/models/ListItem';

const resource = '/user';

export default {
  /**
   * @param {number} userId
   * @returns {Promise<ListItem[]>}
   */
  async getUserStores(userId) {
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    const response = await Axios.get(`${resource}/${userId}/stores`, { headers });
    return response.data.map((item) => (new ListItem(item)));
  },

  /**
   * @param {string} username
   * @returns {Promise<ListItem[]>}
   */
  async getUserStoresByQuery(username) {
    const params = {
      username,
    };
    const response = await Axios.get(`${resource}/stores`, { params });
    return response.data.map((item) => (new ListItem(item)));
  },

  /**
   * @param {number} userId
   * @returns {Promise<string[]>}
   */
  async getUserAttributes(userId) {
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    const response = await Axios.get(`${resource}/${userId}/attributes`, { headers });
    return response.data.data;
  },
};
